import { h, FunctionalComponent } from 'preact'
import { z } from 'zod'
import { GetServerSideProps } from '../../server-middleware/context'

interface HTMLWidgetProps{
  title: string
  html?: string
}

export const widgetName = 'html_widget'

export const config = z.object({
  title: z.string(),
  html: z.string().optional()
})

type Config = z.infer<typeof config>

export const getServerSideProps: GetServerSideProps<Config, HTMLWidgetProps> = async (_, config) => {
  return {
    title: config.title,
    html: config.html
  }
}

const CustomHtml: FunctionalComponent<HTMLWidgetProps> = ({ title, html }: HTMLWidgetProps) => {
  return (
    <div className='custom-html-widget-wrapper'>
      {title
        ? (<div className='sitewidth'>
          <div className='col'>
            <h3 className='widget__heading'>{title}</h3>
          </div>
        </div>)
        : null}
      <section className='full-width custom-html' dangerouslySetInnerHTML={{ __html: html || '' }} />
    </div>
  )
}

export default CustomHtml
